import { defineMessages } from 'react-intl';

// Centralized messages for native blocking flows
export const blockedMessages = defineMessages({
  blockedContent: {
    id: 'ZBP2Ys',
    defaultMessage: "You have blocked this user's content.",
  },
  blockedUserLabel: {
    id: 'auMlbc',
    defaultMessage: 'Blocked user',
  },
  block: {
    id: 'vdAg+H',
    defaultMessage: 'Block this user',
  },
  unblock: {
    id: 'cotg7u',
    defaultMessage: 'Unblock this user',
  },
  unblockShort: {
    id: 'nDejmx',
    defaultMessage: 'Unblock',
  },
  blockedAt: {
    id: 'kz7qzu',
    defaultMessage: 'Blocked on {blockedAt}',
  },
  tabBlocked: {
    id: 'qUJTsT',
    defaultMessage: 'Blocked',
  },
  title: {
    id: 'skNNbV',
    defaultMessage: 'Blocked users',
  },
  empty: {
    id: 'hBL2+R',
    defaultMessage: "You haven't blocked any users yet.",
  },
  nonNative: {
    id: 'kvVdZi',
    defaultMessage: 'Blocking is only available in the native app.',
  },
  blockConfirmationDefault: {
    id: 'L/nucD',
    defaultMessage: 'Are you sure you want to block this user?',
  },
  blockConfirmationPseudo: {
    id: 'fangp1',
    defaultMessage: 'Are you sure you want to block {pseudo}?',
  },
});
